
import React, { useState, useRef } from 'react';
import ModalWrapper from './ModalWrapper';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimePicker from 'react-time-picker';
import { BaseUrl } from '../../../Actions/Base';
import ReactSelect from "react-select"; // renamed to avoid conflict
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import LearnerPreSchedule from "../Assets/LearnerPreSchedule.png";
import Draggable from 'react-draggable';

const AddClassWeeklySchedulePopup = ({
    showAddClassPopup,
    setShowOwnTimeFields,
    instructorTypeExtracted,
    InstructorState,
    setCombinedEvents,
    instituteClasses,
    studentScheduleEvents,
    setAddClassEvents,
    addClassEvents,
    CoursePackage,
    timeSlots,
    selectedDate,
    selectedDay,
    setSelectedDay,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    handleAddClass,
    error,
    setError,
    isSeparateSchedule,
    handleSeparateScheduleAddClass,
    setSelectedWeeklyScheduleDate,
    selectedWeeklyScheduleDate,
    handleSelect,
    setShowStudentFreeHoursPopup,
    setShowInstituteTrainingFreeHoursPopup,
    StudentAllCoursesSchedule,
    showStudentFreeHoursPopup,
    showInstituteTrainingFreeHoursPopup,
    showLearnerPreSchedulePopup
}) => {
  const Days = [...new Set(timeSlots?.map(slot => slot.DayOfWeek))];
  console.log("Days in AddClassPopup is:",Days);
  console.log("selectedDate in add class is:",selectedDate)

  const reactSelectDayOptions = Days.map((day) => ({ label: day, value: day }));

  const typeToIndex = {
    Driving: 0,
    Online: 1,
    InClass: 2,
  };
 
  const idx = typeToIndex[instructorTypeExtracted] ?? 0;
  const chosenInstructor = InstructorState[idx] || {};
  console.log("chosenInstructor in add class is:",chosenInstructor)
  const instructorImgSrc = chosenInstructor.InstructorImage
    ? `${BaseUrl}/api/images/Instructors?url=${chosenInstructor.InstructorImage}`
    : null;

  const instructorFullName = chosenInstructor.InstructorName || "";

   // Function to handle date selection by the user
   const handleDateChange = (newValue) => {
    setSelectedWeeklyScheduleDate(newValue);
}; 

  const handleCancelPopupClick = () =>{
    setSelectedWeeklyScheduleDate(null);
    setError("");
    setShowStudentFreeHoursPopup(false);
    setShowInstituteTrainingFreeHoursPopup(false);
    setShowOwnTimeFields(false)
  }
  
  const isAnyPopupOpen = showStudentFreeHoursPopup || showInstituteTrainingFreeHoursPopup || showLearnerPreSchedulePopup;

  return (
    <Draggable disabled={showStudentFreeHoursPopup || showInstituteTrainingFreeHoursPopup || showLearnerPreSchedulePopup}>
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[20px] pt-[20px] shadow-lg w-[400px]"
         style={{
            cursor: 'move', // 👈 This makes the whole box show move cursor
            // ...(isAnyPopupOpen && {
            //   position: 'relative',
            //   left: '50%',
            //   top: '10%',
            //   transform: 'translate(-50%, -50%)',
            // }),
          }}> 
            <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] pointer-events-auto z-50"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={handleCancelPopupClick}
              />
            </div>

            {(instructorTypeExtracted !== "Online") && (
            <div className='w-full flex-col gap-[15px] absolute top-[5px] left-3'>
              <div className='w-full flex gap-[10px] '>
                  <img src={require("../Assets/LearnerHours.svg").default} alt="" className="cursor-pointer" title="Learner Free Hours" // Tooltip here 
                    onClick={() => handleSelect('freeHours')}/>
                   <img src={LearnerPreSchedule} alt="" className="cursor-pointer" title="Learner Pre-Scheduled Classes" // Tooltip here
                    onClick={() => handleSelect('LearnerPreSchedule')} />
              </div>
              <div>
                {StudentAllCoursesSchedule?.length > 0 && (
                  <img src={require("../Assets/TrainingHours.svg").default} alt="" className="cursor-pointer" title="Institute Training Hours" // Tooltip here
                  onClick={() => handleSelect('weeklySchedule')} />
                  )}
              </div>
            </div>
            )
            }
          
          <div className='w-full flex flex-col justify-center gap-[5px] items-center mt-[-120px]'>
              <img src={require("../Assets/AddClassPopupPics.svg").default} alt="" className="h-[130px] 2.5xl:auto" />
              <p className='text-[16px] font-semibold mt-[5px]'>
                  Set up class Schedule ({instructorTypeExtracted === 'Driving' ? 'In-Vehicle' : instructorTypeExtracted})
              </p>
              <p className='text-[16px]'>Set up a new class for the learner.</p>
          </div>

          <div className='mt-[10px] w-full rounded-[12px] p-[5px] flex gap-[15px] items-center' style={{ border: '2px solid #AEB0FF' }}>
            <img className="w-[46px] h-[46px] rounded-full" src={instructorImgSrc} alt="" />
            <p className="text-[16px] font-semibold">{instructorFullName} ({instructorTypeExtracted === 'Driving' ? 'In-Vehicle' : instructorTypeExtracted})</p>
          </div>

          
          <div className='flex flex-col pt-[10px] gap-[10px]'>
            <div className='flex items-center gap-[35px]'>
                <p className='text-[16px] text-[#333333] font-semibold'>Date</p>
                <div className='w-full'>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                      {/* <DatePicker
                          value={selectedWeeklyScheduleDate}
                          onChange={handleDateChange}
                          renderInput={(params) => 
                            <TextField
                              {...params}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor: '#AEB0FF',
                                  },
                                  '&:hover fieldset': {
                                    borderColor: '#AEB0FF',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#AEB0FF',
                                  },
                                  backgroundColor: 'transparent',
                                },
                                input: {
                                  color: '#333333',
                                  height: '15px',
                                  padding: '5px',
                                },
                              }}
                              PopperProps={{
                                  modifiers: [
                                    {
                                      name: 'offset',
                                      options: {
                                        offset: [0, 10], // slight space between input and popup
                                      },
                                    },
                                    {
                                      name: 'preventOverflow',
                                      options: {
                                        altAxis: true, // allow flipping to top if bottom is cut
                                        tether: false,
                                      },
                                    },
                                    {
                                      name: 'flip',
                                      options: {
                                        fallbackPlacements: ['top', 'right'],
                                      },
                                    },
                                  ],
                                }}
                            />}
                      /> */}
                      <DatePicker
                          value={selectedWeeklyScheduleDate}
                          onChange={handleDateChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              sx={{
                                '& .MuiOutlinedInput-root': {
                                  '& fieldset': {
                                    borderColor: '#AEB0FF',
                                  },
                                  '&:hover fieldset': {
                                    borderColor: '#AEB0FF',
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#AEB0FF',
                                  },
                                  backgroundColor: 'transparent',
                                },
                                input: {
                                  color: '#333333',
                                  height: '5px',
                                  padding: '0px',
                                },
                              }}
                            />
                          )}
                          PopperProps={{
                            placement: 'top-start', // 🚀 force it to open upwards
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, 10], // slight space between input and popup
                                },
                              },
                              {
                                name: 'preventOverflow',
                                options: {
                                  altAxis: true, // allow flipping to top if bottom is cut
                                  tether: false,
                                },
                              },
                              {
                                name: 'flip',
                                options: {
                                  fallbackPlacements: ['top', 'right'],
                                },
                              },
                            ],
                            sx: {
                              zIndex: 99999, // 🔥 This ensures it's above your popup
                            },
                          }}
                        />
                  </LocalizationProvider>
                </div>
            </div>

            <div className=' flex items-center gap-[10px]'>
              <p className='text-[16px] text-[#333333] font-semibold'>From</p>
                {/* <TimePicker
                  onChange={setStartTime}
                  value={startTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                /> */}
                <TimePicker
                  onChange={(value) => {
                    if (value) {
                      const [hours, minutesRaw] = value.split(':');
                      const minutes = parseInt(minutesRaw, 10);

                      // Only accept 0 or 30 minutes
                      if (minutes !== 0 && minutes !== 30) {
                        setError("Only 0 or 30 minutes allowed");
                        setStartTime(null); // or keep the previous
                        return;
                      }

                      setError('');
                      setStartTime(value);
                    } else {
                      setStartTime(null);
                    }
                  }}
                  value={startTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                />
            </div>

            <div className='flex items-center gap-[30px]'>
              <p className='text-[16px] text-[#333333] font-semibold'>To</p>
                {/* <TimePicker
                  onChange={setEndTime}
                  value={endTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                /> */}
                <TimePicker
                  onChange={(value) => {
                    if (value) {
                      const [hours, minutesRaw] = value.split(':');
                      const minutes = parseInt(minutesRaw, 10);

                      if (minutes !== 0 && minutes !== 30) {
                        setError("Only 0 or 30 minutes allowed");
                        setEndTime(null);
                        return;
                      }

                      setError('');
                      setEndTime(value);
                    } else {
                      setEndTime(null);
                    }
                  }}
                  value={endTime}
                  disableClock
                  clearIcon={null}
                  format="h:mm a"
                  className="custom-time-picker"
                />
            </div>

            {/* {error && <p className="text-[#FF0000]">{error}</p>} */}

            <div className='mt-[10px] w-full flex flex-col justify-center items-center gap-[10px]'>
                <button
                  type="button"
                  className="rounded-[5px] bg-[#B5AAFF] w-[302px] h-[42px] text-[14px] text-white"
                  // onClick={handleAddClass}
                  onClick={() => {
                    isSeparateSchedule ? handleSeparateScheduleAddClass() : handleAddClass();
                  }}
                >
                  Add Class
                </button>
              
                <button
                  type="button"
                  className=" text-[#B5AAFF] text-[14px]"
                  onClick={handleCancelPopupClick}
                >
                  Cancel
                </button>
            </div>
          </div>
        </div>
    </Draggable>
  );
};

export default AddClassWeeklySchedulePopup;



// <ModalWrapper isOpen={showAddClassPopup} onClose={() => setShowOwnTimeFields(false)}>
    //   <p className='text-[26px] text-[#4C34AD] font-semibold'>
    //     Custom Time Schedule ({instructorTypeExtracted})
    //   </p>

    //   <div className='mt-[10px] w-full rounded-[12px] p-[20px] flex gap-[20px] items-center' style={{ border: '1px solid #B7B7B7' }}>
    //     <img className="w-[55px] h-[55px] rounded-full" src={instructorImgSrc} alt="" />
    //     <p className="text-[23px]">{instructorFullName}</p>
    //   </div>

    //   <div className='mt-[10px] w-full rounded-[12px]' style={{ border: '1px solid #B7B7B7' }}>
    //     <div style={{ borderBottom: '1px solid #B7B7B7' }}>
    //       <div className='flex items-center gap-[5px] px-[15px] mt-[15px] mb-[10px]'>
    //         <AccessTimeIcon />
    //         <p className='text-[19px] text-[#333333] font-semibold'>Date And Time</p>
    //       </div>
    //     </div>
    //     <div className='flex flex-col py-[15px] px-[20px] gap-[15px]'>
    //       <div className='flex items-center gap-[70px]'>
    //         <p className='text-[19px] text-[#333333] font-semibold'>On</p>
    //         <div className='w-full'>
    //             <LocalizationProvider dateAdapter={AdapterMoment}>
    //                 <DatePicker
    //                     value={selectedWeeklyScheduleDate}
    //                     onChange={handleDateChange}
    //                     renderInput={(params) => <TextField {...params} style={{ height: '30px' }} />}
    //                 />
    //             </LocalizationProvider>
    //         </div>

    //       </div>

    //       <div className='flex items-center gap-[20px]'>
    //         <p className='text-[19px] text-[#333333] font-semibold'>From</p>
    //         <TimePicker
    //           onChange={setStartTime}
    //           value={startTime}
    //           disableClock
    //           clearIcon={null}
    //           format="h:mm a"
    //           className="custom-time-picker"
    //         />
    //       </div>

    //       <div className='flex items-center gap-[45px]'>
    //         <p className='text-[19px] text-[#333333] font-semibold'>To</p>
    //         <TimePicker
    //           onChange={setEndTime}
    //           value={endTime}
    //           disableClock
    //           clearIcon={null}
    //           format="h:mm a"
    //           className="custom-time-picker"
    //         />
    //       </div>

    //       {error && <p className="text-[#FF0000]">{error}</p>}

    //       <div className='mt-[10px] w-full flex justify-center items-center gap-[20px]'>
    //         <button
    //           type="button"
    //           className="rounded-[10px] w-[121px] h-[42px] text-[#4C34AD] text-[19px]"
    //           style={{ border: '2px solid #4C34AD' }}
    //           // onClick={() => setShowOwnTimeFields(false)}
    //           onClick={handleCancelPopupClick}
    //         >
    //           Cancel
    //         </button>

    //         <button
    //           type="button"
    //           className="rounded-[10px] bg-[#4C34AD] w-[121px] h-[42px] text-[19px] text-white"
    //           onClick={() => {
    //             isSeparateSchedule ? handleSeparateScheduleAddClass() : handleAddClass();
    //           }}
    //         >
    //           Add Class
    //         </button>
    //       </div>
    //     </div>
    //   </div>
    // </ModalWrapper>